import { Component, OnInit, Input, HostListener, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AppManagementService } from '../../services/app-management.service';
import { QuestionService } from '../../services/question.service';
import { CustomService } from '../../services/custom.service';
import { AppTexts, ScreenNames } from '../../objects/app-static-texts';

import { GeoService } from '../../services/geo.service';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Country } from '../../objects/country';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers: [QuestionService]
})
export class FormComponent implements  OnInit, AfterViewInit, OnDestroy {

  @Input('countryCode') countryCode: string;
  selectedCountryCode = 'us';
  country_code_activated: boolean = false;
  country_code_field:any;
  phoneCode = '1';
  countryCodes = [];
  
  pageDesignFlag: boolean =false;
  pageDesign: any;
  fileData: File = null;
  labelColor: any;
  labelStyle: any;
  hintColor: any;
  form: FormGroup;
  payLoad = '';
  matApperance: string = "fill";
  
  form_fields: any = [];
  
  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;

  // VARIABLE FOR STORING CUSTOM CODE STRING
  htmlText: any;

  /** list of countries */
  protected countries: Country[];

  /** control for the selected bank */
  public countryCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword */
  public countryFilterCtrl: FormControl = new FormControl();

  /** list of countries filtered by search keyword */
  public filteredCountries: ReplaySubject<Country[]> = new ReplaySubject<Country[]>(1);

  @ViewChild('singleCountrySelect', { static: true }) singleCountrySelect: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  scroll_listener;
  constructor(private fb: FormBuilder,
    public appDesignService: AppManagementService,
    private questionService: QuestionService,
    public customService:CustomService,
    public geoService: GeoService) {  }

  ngOnInit(): void {
    this.pageDesign = this.appDesignService.getPageDesign();
    
    if(this.pageDesign!=undefined){
      this.pageDesignFlag = true;
      this.appDesignService.addToScreenHistory(this.pageDesign.name,"page");

      this.countries = this.geoService.getAllCountries();
      
      // load the initial bank list
      this.filteredCountries.next(this.countries.slice());

      // listen for search field value changes
      this.countryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCountries();
        });
      
      //SENDING PAGE VIEW FOR GA
      this.customService.sendPageViewUpdate(this.pageDesign.name);

      //IF PAGE DESIGN HAVE CUSTOM CODE
      if(this.pageDesign.custom_code !=undefined){

        //DECODE BASE64 CUSTOM CODE TO STRING
        this.htmlText = atob(this.pageDesign.custom_code);
        
        this.customDesign = true;

        var start=0;
        var end=0;
        
        for(let i = 0; i < this.htmlText.length; i++){
          
          if(this.htmlText[i]+""+this.htmlText[i+1] == "{{"){
              start = i+2
          }
          
          if(this.htmlText[i]+""+this.htmlText[i+1] == "}}"){
              end = i;
          }
          
          if(start-end<0){
          
            var c = this.htmlText.substring(start,end);
          
            var value = '';  
          
            for(var e=0;e<this.pageDesign.element_flow.length;e++){
          
              if(this.pageDesign.element_flow[e].element_keyname == c){
          
                switch(this.pageDesign.element_flow[e].element_keyname.element_keyname) {
          
                  case 'screen_image_1':
          
                    value = this.customService.imageUrl;
            
                    break;
                    
                  case 'screen_input_label':
        
                    value = this.pageDesign.element_flow[e].label;

                    break;
              
                  default:
            
                    value = this.pageDesign.element_flow[e].text;
            
                }
              
              }
            
            }

            this.htmlText = this.htmlText.replace("{{"+c+"}}",value);
            
            start = end = 0;
          
          }
        
        }

      }
      
      this.pageDesign["style"] = this.appDesignService.applyElementStyle(this.pageDesign);

      //NORMAL ELEMENT FLOWS STACK LIST
      if(this.pageDesign.element_flow!=undefined){ 
        for (var t = 0; t < this.pageDesign.element_flow.length; t++) {
          this.pageDesign.element_flow[t]["style"] = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[t]);
          if (this.pageDesign.element_flow[t].type == 'input') {
            this.pageDesign.element_flow[t]["control"] = this.questionService.getInput(this.pageDesign.element_flow[t]);
          }
        }

        if(this.pageDesign.inputs_ele!=undefined){
          for (var t = 0; t < this.pageDesign.inputs_ele.length; t++) {
            this.pageDesign.inputs_ele[t]["style"] = this.appDesignService.applyElementStyle(this.pageDesign.inputs_ele[t]);
          }
        }
    
        this.labelStyle = this.appDesignService.getFormInputStyle('mat-label');
      
        if(this.labelStyle!=undefined){
          this.labelColor = '#f1c40f';
          this.hintColor = this.labelStyle.color;
        }
        this.createInputElementUIArray();
      }  

      // // this.appDesignService.scrollToTop();
      
      setTimeout(() => { this.updateIframeHeight(); }, 300);
      this.captureImageLoadEvent();
    }
    else{
      this.appDesignService.redirectAppToBase();
    }
    
  }

  captureImageLoadEvent(){
    var imgs = document.querySelectorAll('img')
    for(var im=0;im<imgs.length;im++){
      if (imgs[im].complete) {
        this.updateIframeHeight()
      } else {
        imgs[im].addEventListener('load', this.updateIframeHeight)
        imgs[im].addEventListener('error', function() { })
      }
    } 
  }

  createGroup() {
    const group = this.fb.group({});

    if(this.form_fields!=undefined){

      this.form_fields.forEach(function (ele) {
        if (ele.control != undefined) {
          var temp_validators = [];

          if(ele.control.required){

            temp_validators.push(Validators.required);

          } 
          switch (ele.type) {
            
            case 'email':
              
              temp_validators.push(Validators.email);
              temp_validators.push(Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/));
              
              break;
            
            case 'number':
              
              temp_validators.push(Validators.pattern("^[0-9]*$"));
            
            break;

            case 'phone':
              
              temp_validators.push(Validators.pattern("^[0-9]*$"));
            
            break;
    
            case 'textarea':

              break;
    
            default:
              break;
          }
          group.addControl(ele.control.key, new FormControl('', temp_validators));
        
        }

      });

    }
    return group;
  
  }

  fileProgress(fileInput: any) {
  
    this.fileData = <File>fileInput.target.files[0];
  
    this.customService.baseConversion(this.fileData);
  
  }

  goBack(){
    this.customService.setBackButtonClicked(true);
    this.appDesignService.popFromScreenHistory();
    this.appDesignService.loadPrevious();
  }

  keyboardEvent(event , form){
    switch (event.code) {
      case 'Enter': {
        var elements = this.pageDesign.element_flow;
        if(elements!=undefined){
          for(var e=0; e<elements.length; e++){
            if(elements[e].type=='submit'){
              if(this.pageDesign.custom_code!=undefined){

                var submit = this.getFormValuesFromCustom();

                if(submit){
                  
                  this.customService.triggerFunction(this.pageDesign.element_flow[e]);
                
                }

              }
              else{
                
                this.customService.submitFunction(elements[e], form);
            
              }
            }
          }
        }
        break;
      }
      default: {
        break;
      }
    }
    
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.goBack();
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {   
    if(event.target.name == 'back_button'){
      this.loadPrevious();
    }

    for(var e=0;e<this.pageDesign.element_flow.length;e++){
      if(this.pageDesign.element_flow[e].type=="submit" && this.pageDesign.element_flow[e].element_keyname == event.target.id){
        var submit = this.getFormValuesFromCustom();
        if(submit){
          this.customService.triggerFunction(this.pageDesign.element_flow[e]);        
        }
      }
    }
  }

  getFormValuesFromCustom(){

    var flag = true;

    for(var i=0;i<this.pageDesign.element_flow.length;i++){

      if(this.pageDesign.element_flow[i].type == "input"){

        var element =  <HTMLInputElement>document.getElementById(this.pageDesign.element_flow[i].element_keyname);
        
        var val = (<HTMLInputElement>document.getElementById(this.pageDesign.element_flow[i].element_keyname)).value;
        
        if(val !="" && element.required){
          
          this.customService.setFormKeyData(this.pageDesign.element_flow[i].form_key, val);

        }
        else{
          
          element.nextElementSibling.classList.remove('hide');
          
          setTimeout(() => {
          
            element.nextElementSibling.classList.add('hide');
          
          }, 2000);
          
          flag = false;
          
        }

      }

    }

    return flag;
  
  }
 
  createInputElementUIArray(){
     
    //LIST OF INPUT FIELDS
    this.form_fields =  this.pageDesign.inputs_ele;
    
    if(this.form_fields!=undefined){
   
      for (var e = 0; e < this.form_fields.length; e++) {
        
        if(this.form_fields[e].matApperance==undefined){
          this.form_fields[e].matApperance = this.matApperance;
        }

        switch (this.form_fields[e].type) {
          case 'text':
            
            this.form_fields[e]["control"] = this.questionService.getInput(this.form_fields[e]);
            
            break;
          
          case 'date':
            
            this.form_fields[e]["control"] = this.questionService.getInput(this.form_fields[e]);
            
            break;

          case 'email':
          
            this.form_fields[e]["control"] = this.questionService.getInput(this.form_fields[e]);
            
            break;

          case 'number':
          
            this.form_fields[e]["control"] = this.questionService.getInput(this.form_fields[e]);
            
          break;

          case 'custom':
            
            this.form_fields[e]["customHtml"] =  atob(this.form_fields[e]["innerHTML"]);
            
          break;

          case 'phone':
          
            this.form_fields[e]["control"] = this.questionService.getInput(this.form_fields[e]);
            
            if(this.form_fields[e].ext!=undefined){

              this.country_code_activated = this.form_fields[e].ext;
            
              this.country_code_field = this.form_fields[e];

              var country = this.getCountrySelected(this.country_code_field.default_code.country_code);

              // set initial selection
              this.countryCtrl.setValue(country);

            }

            if(this.form_fields[e].default_code!=undefined){
            
              this.selectedCountryCode = this.form_fields[e].default_code.country_code;

              this.phoneCode = this.form_fields[e].default_code.phone_code;
            
            }

          break;
          
          case 'textarea':
        
            this.form_fields[e]["control"] = this.questionService.getInput(this.form_fields[e]);
          
          break;

          default:
            break;
        }
   
        if(this.form_fields[e].classes!=undefined){
          
          var mob = []
          
          var common = this.form_fields[e].classes.common;
          
          if(this.appDesignService.isMobile){
            
            if(this.form_fields[e].classes.mobile!=undefined){
            
              mob =this.form_fields[e].classes.mobile;
            
            }
          
          }
          
    
          const final_classes =  common.concat(mob);
    
          this.form_fields[e].style =  this.appDesignService.applyStyles(final_classes);

        }

      }
   
    }

    this.labelStyle = this.appDesignService.getFormInputStyle(AppTexts.MatLabel);
    
    if(this.labelStyle!=undefined){
    
      this.labelColor = '#f1c40f';
    
      this.hintColor = this.labelStyle.color;
    
    }
    
    this.form = this.createGroup();

  }

  submitFunction(field,form){
    Object.keys(form.controls).forEach(field => {  //{2}
      const control = form.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
    
      } else if (control instanceof FormGroup) {        //{5}
        // this.validateAllFormFields(control);            //{6}
      }
    });

    if(this.country_code_activated){
    
      if(form.value[this.country_code_field.key]!=""){
        
        form.value[this.country_code_field.key] = this.phoneCode+""+form.value[this.country_code_field.key];
      
      }
      else{

        delete form.value[this.country_code_field.key]; 
        
      }
    
    }

    if(form.status=="VALID"){
      this.customService.submitFunction(field, form);     
    }
  
  }

  public checkError = (controlName: string, errorName: string) =>{
    return this.form.controls[controlName].hasError(errorName);
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected setInitialValue() {
    this.filteredCountries
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        // this.singleSelect.compareWith = (a: Country, b: Country) => a && b && a.name === b.name;
      });
  }

  protected filterCountries() {
    if (!this.countries) {
      return;
    }
    // get the search keyword
    let search = this.countryFilterCtrl.value;
    if (!search) {
      this.filteredCountries.next(this.countries.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredCountries.next(
      this.countries.filter(country => country.name.toLowerCase().indexOf(search) > -1)
    );
  }

  callButtonFunction(field){
    for(var f=0; f<this.form_fields.length; f++){
      if(this.form_fields[f].key!=undefined){
        if(this.form.controls[this.form_fields[f].key].errors!=null){
          this.form.controls[this.form_fields[f].key].errors.required = false;
        }
        this.form.controls[this.form_fields[f].key].clearValidators();
      }
    }
    this.customService.triggerFunction(field);
  }

  getCountrySelected(cCode){
    var val = this.countries[0];
    
    for(var c=0;c<this.countries.length;c++){
      
      if((this.countries[c].twoLetterCode).toLowerCase() == cCode.toLowerCase()){
       
        val = this.countries[c];
      
      }
    
    }

    this.selectedCountryCode = (val.twoLetterCode).toLowerCase();

    this.phoneCode = val.countryCode;

    return val;
  }

  changeCountry(select){ this.getCountrySelected(select._value.twoLetterCode); }
  
  loadPrevious(){
    
    // CHECK IF SURVEY HAS ALREADY STARTED
    var flag= this.customService.isSurveyContinued();
    
    var selected_queries = this.customService.getSelectedQueries();
    if(selected_queries!=undefined){
      if(selected_queries.length<1) { flag = false; }
    } else {
      flag = false;
    }

    if(flag){
      var selectedOptions = this.customService.getSelectedQueries();
      var remOp = selectedOptions[selectedOptions.length-1];
      
      if(remOp.type == AppTexts.screen && remOp.screen_name == ScreenNames.selfie){
        selectedOptions.pop();
        this.customService.saveSelectedQueries(selectedOptions);
      }
      this.appDesignService.popFromScreenHistory();
      // this.customService.setBackButtonClicked(true);
      this.customService.loadSurveyScreen();
    } else {
      this.appDesignService.loadPrevious();
    }
  }
  
  ngAfterViewChecked(){ this.updateIframeHeight(); }

  ngDoCheck() { this.updateIframeHeight(); }

  ngAfterContentChecked() { this.updateIframeHeight(); }

  updateIframeHeight(){
    if(this.pageDesign!=undefined){
      var ele = document.getElementById(this.pageDesign.name);
      if(ele!=null && ele!=undefined){        
        this.appDesignService.sentHeight(ele.offsetHeight);
      }
    }
  }

}
